import axios from "axios";
import { useContext } from "react";
import Loader from "../../components/Loader";
import IconsStatus from "../../components/IconStatus";
import { AuthContext } from "../../context/AuthContext";
import { UmbrellaRoamingColumn } from "../../components/headerContent";
import { useQuery } from "@tanstack/react-query";
import Table from "../../components/Table";
import NumberCard from "../../components/Card/NumberCard";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

export default function Roaming() {
  const { apiUrl } = useContext(AuthContext);


  // Request
  const getRoamingComputers = async () => {
    const res = await axios(`${apiUrl}umbrella/roaming_computers`, {
      method: "get",
      withCredentials: true,
    })
    return res.data
  };

  const roaming = useQuery({
    queryKey: ["roaming"],
    queryFn: getRoamingComputers
  })

  const roamingData = Array.isArray(roaming.data) ? roaming.data : [];
  const onlinePercentage = roamingData.length > 0
    ? Math.round((roamingData.filter((item) => item.status !== "Off").length * 100) / roamingData.length)
    : 0;

  return (
    <>
      {!roaming.isLoading ? (
        <>
          <section className="page-section mt-1">
            <NumberCard title="Client en ligne"
              number={`${onlinePercentage}%`}
              logo={faCircleCheck}
              color={"#AEC353"}
              stylesIcons={"logo-certificats"}
            />
          </section>
          <div className='cato-content-table'>
            <Table
              tableColumns={UmbrellaRoamingColumn}
              tableData={roamingData}
              checkbox={false}
            />
          </div>
        </>
      ) : (
        <Loader />
      )}
    </>
  );
}
